module.exports = __webpack_public_path__ + "img/fbjersey.a0ccef23.svg";